// This component is for coverage tab in Application form 
// To add coverage based on plan class and practice counties
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6 coverage-tab">
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-3">
        <h2 class="text-lg font-medium leading-6 text-gray-900 mt-2">COVERAGES</h2>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div
            class="shadow sm:rounded-md sm:overflow-hidden xl:w-4/5 md:w-full sm:w-full coverage-div"
          >
            <div class="bg-white py-6 px-4 space-y-6 sm:p-2">
              <div class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341]">
                <i class="fa fa-info-circle text-[#1f3341]"></i>
                Please review the Fee Schedule before you make your coverage
                selections. You can view our Fee Schedule as a PDF or you can
                view it by clicking the Fee Schedule hyperlinks below for each
                legal coverage.
                <br />
                <br />Please note that coverage will vary depending on the member’s
                plan. You must contact our Authorizations Department prior to
                proceeding with a member’s legal matter in order to determine
                the member’s coverage.
                <div class="tooltip mt-1" v-if="form.stateCount['Others'] > 0">
                  Attorney Fee Reimbursement Schedule
                  <a
                    href="https://hubs.ly/Q045DThS0"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download Attorney Fee Reimbursement Schedule"
                  >
                    <i class="ml-2 fa fa-download cobalt-text-color cursor-pointer" aria-hidden="true"></i>
                  </a>
                  <span class="tooltip-text">Download</span>
                </div>
                <div class="tooltip mt-1" v-if="form.stateCount['CA'] > 0">
                  USL Fee Schedule - California
                  <a
                    :href="
                      API_BASE +
                        'downloadAggreementFiles.php?name=USL Fee Reimbursement Schedule - California.pdf&folder=agreement_pdfs'
                    "
                    aria-label="Download USL Fee Schedule - California (PDF)"
                  >
                    <i class="ml-1 fa fa-download cobalt-text-color cursor-pointer" aria-hidden="true"></i>
                  </a>
                  <span class="tooltip-text">Download</span>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <span id="attorney-type-label" class="block text-sm font-medium text-gray-900">
                  Attorney Type
                  <span class="text-red-700">*</span>
                </span>
                <div role="group" aria-labelledby="attorney-type-label">
                  <label
                    v-for="(item, index) in attorney_types"
                    :key="index"
                    class="inline-flex items-center mt-3 ml-2"
                  >
                    <input
                      type="checkbox"
                      :value="item.id"
                      :id="'attorney_type' + index"
                      v-model="form.attorney_type"
                      @change="getCoverages(item.id)"
                      class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                    />
                    <span class="ml-2 text-gray-800">{{ item.name }}</span>
                  </label>
                </div>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.attorney_type.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                </div>
              </div>
              <div class="barley-corn-bg-color-3 border-l-4 cobalt-border-color-3 p-4 text-[#1f3341]">
                <ul class="list-disc ml-5">
                  <li>
                    Family Defender (
                    <b>FAM</b> Plan Class) - You will accept
                    matters that will be paid out in accordance with the
                    corresponding U.S. Legal Services Inc. Attorney Fee
                    Schedule. Please indicate all areas of practice in which you
                    will accept matters that will be paid out in accordance with
                    the corresponding U.S. Legal Services Inc. Attorney Fee
                    Schedule. Also, please indicate whether you have the
                    capability to provide legal services 100% remotely for each
                    area of coverage in which you elect to provide services.
                  </li>
                  <li>
                    CDL Defender (
                    <b>CDL</b> Plan Class) - You will accept CDL
                    covered cases and/or CDL referral cases. Please indicate if
                    you will accept CDL covered cases and/or CDL referral cases.
                  </li>
                  <li>
                    Referral (
                    <b>REF</b> Plan Class) - You will accept referrals
                    of U. S. Legal plan members to provide a free consultation
                    and bill the member directly at a discount of at least 33%
                    off your normal hourly rate for Non-Covered legal services.
                    Please indicate the practice areas for which you will accept
                    referrals of U. S. Legal plan members to provide a free
                    consultation and bill the member directly at a discount of
                    at least 33% off your normal hourly rate for Non-Covered
                    legal services.
                  </li>
                  <li>
                    <b>Remote Consulting</b> - you can provide consultations remotely.
                  </li>
                  <li>
                  <b>Remote Services</b> - you can provide services (past the initial consultation) remotely.
                  </li>
                </ul>
              </div>
              <h2 class="text-lg leading-6 font-medium text-gray-900">Coverages
                <span class="text-red-700">*</span>
              </h2>
              <div class="overflow-x-auto coverages-table-wrap">
                <table class="coverages-table divide-y divide-gray-200 w-full table-fixed">
                  <colgroup>
                    <col class="col-coverage" />
                    <col class="col-plan" />
                    <col class="col-remote" />
                    <col class="col-remote" />
                  </colgroup>
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Coverage</th>
                      <th
                        scope="col"
                        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Plan Class</th>
                      <th
                        scope="col"
                        class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Remote Consulting</th>
                      <th
                        scope="col"
                        class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >Remote Services</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(item, i) in coverages" :key="i">
                      <td colspan="4" class="p-0 align-middle">
                        <div :class="['coverage-row', { tab: hasSubCoverages(item) }]">
                          <a
                            href="javascript:;"
                            class="sr-only"
                            @click="openfeeSchedule(true, item)"
                            v-if="item.fee_schedule.length > 0 && !form.attorney_type.includes('FAM')"
                            :aria-label="'Open fee schedule for ' + item.desc"
                          >
                            Fee Schedule
                          </a>

                          <input
                            v-if="hasSubCoverages(item)"
                            class="sr-only tab-checkbox"
                            :id="'tab-multi-one' + i"
                            type="checkbox"
                            name="tabs"
                          />

                          <div class="coverage-row-header">
                            <div class="coverage-cell">
                              <div class="coverage-cell-inner">
                                <span class="coverage-name">
                                  {{ item.desc }}
                                  <span v-if="item.is_required" class="text-red-700">*</span>
                                </span>
                                <label
                                  v-if="hasSubCoverages(item)"
                                  class="coverage-sub-btn"
                                  :for="'tab-multi-one' + i"
                                >View Sub-coverages</label>
                                <span
                                  v-else
                                  class="coverage-sub-btn-spacer"
                                  aria-hidden="true"
                                ></span>
                              </div>
                            </div>

                            <div class="plan-class-cell">
                              <div class="plan-class-group">
                                <label
                                  class="plan-class-option"
                                  v-for="(item2, index1) in sortedPlanClasses(item.plan_class)"
                                  :key="index1"
                                >
                                  <input
                                    :id="'coverage_' + i + '_' + index1"
                                    type="checkbox"
                                    @change="
                                      check(
                                        { plan_class: item2, desc: item.desc },
                                        'coveragelist',
                                        $event
                                      )
                                    "
                                    class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                                  />
                                  <span class="text-gray-800">{{ item2 }}</span>
                                </label>
                              </div>
                            </div>

                            <div class="remote-cell">
                              <template v-if="!hasSubCoverages(item)">
                                <div
                                  class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in"
                                >
                                  <input
                                    type="checkbox"
                                    name="toggle"
                                    :id="'toggle_' + i"
                                    :aria-label="'Remote Consulting for ' + item.desc"
                                    @change="
                                      check(
                                        { desc: item.desc },
                                        'remote_consulting',
                                        $event
                                      )
                                    "
                                    :disabled="
                                      !form?.coveragelist?.some(
                                        (el) => el.desc === item.desc
                                      )
                                    "
                                    class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                  />
                                  <label
                                    :for="'toggle_' + i"
                                    class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                  >
                                    <span class="sr-only">{{ 'Remote Consulting for ' + item.desc }}</span>
                                  </label>
                                </div>
                              </template>
                            </div>

                            <div class="remote-cell">
                              <template v-if="!hasSubCoverages(item)">
                                <div
                                  class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in"
                                >
                                  <input
                                    type="checkbox"
                                    name="toggle"
                                    :id="'toggle_service' + i"
                                    :aria-label="'Remote Services for ' + item.desc"
                                    @change="
                                      check(
                                        { desc: item.desc },
                                        'remote_services',
                                        $event
                                      )
                                    "
                                    :disabled="
                                      !form?.coveragelist?.some(
                                        (el) => el.desc === item.desc
                                      )
                                    "
                                    class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                  />
                                  <label
                                    :for="'toggle_service' + i"
                                    class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                  >
                                    <span class="sr-only">{{ 'Remote Services for ' + item.desc }}</span>
                                  </label>
                                </div>
                              </template>
                            </div>
                          </div>

                          <div
                            v-if="hasSubCoverages(item)"
                            class="tab-content border-l-2 bg-gray-50 border-indigo-500 leading-normal"
                          >
                            <table class="coverages-subtable w-full table-fixed">
                              <colgroup>
                                <col class="col-coverage" />
                                <col class="col-plan" />
                                <col class="col-remote" />
                                <col class="col-remote" />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Sub-coverages</th>
                                  <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Plan Class</th>
                                  <th class="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase">Remote Consulting</th>
                                  <th class="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase">Remote Services</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item1, index) in item.sub_coverage" :key="index">
                                  <td
                                    class="px-4 py-3 align-middle"
                                    v-if="
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class == 'REF') ||
                                      (form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF') ||
                                      (!form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF')
                                  "
                                  >
                                    <span v-if="item.desc == 'Guardianship/Conservatorship'">{{ item1.subcoverage }}</span>
                                    <span v-else>
                                      {{ item.desc }} -
                                      {{ item1.subcoverage }}
                                    </span>
                                  </td>
                                  <td
                                    class="px-4 py-3 align-middle"
                                    v-if="
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class == 'REF') ||
                                      (form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF') ||
                                      (!form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF')
                                  "
                                  >
                                    <div class="plan-class-group">
                                      <label
                                        class="plan-class-option"
                                        v-for="(item2, index1) in sortedPlanClasses(item.plan_class)"
                                        :key="index1"
                                      >
                                        <input
                                          type="checkbox"
                                          :id="'coverage_' + i + '_' + index + '_' + index1"
                                          @change="
                                            check(
                                              {
                                                plan_class: item2,
                                                desc: item.desc,
                                                sub_cov_id: item1.sub_cov_id,
                                                sub_coverage: item1.subcoverage,
                                              },
                                              'coveragelist',
                                              $event
                                            )
                                          "
                                          class="focus:ring-indigo-500 h-6 w-6 cobalt-text-color border-gray-300 rounded"
                                        />
                                        <span class="text-gray-800">{{ item2 }}</span>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    class="px-4 py-3 align-middle text-center"
                                    v-if="
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class == 'REF') ||
                                      (form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF') ||
                                      (!form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF')
                                  "
                                  >
                                    <div class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
                                      <input
                                        type="checkbox"
                                        name="toggle"
                                        :id="'toggle_' + i + '_' + index"
                                        :aria-label="'Remote Consulting for ' + item.desc + ' - ' + item1.subcoverage"
                                        @change="
                                          check(
                                            {
                                              desc: item.desc,
                                              sub_cov_id: item1.sub_cov_id,
                                              sub_coverage: item1.subcoverage,
                                            },
                                            'remote_consulting',
                                            $event
                                          )
                                        "
                                        :disabled="
                                          !form?.coveragelist?.some(
                                            (el) => el.desc === item.desc
                                          ) ||
                                            !form.coveragelist.some(
                                              (el) =>
                                                el.sub_coverage ===
                                                item1.subcoverage
                                            )
                                        "
                                        class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                      />
                                      <label
                                        :for="'toggle_' + i + '_' + index"
                                        class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                      >
                                        <span class="sr-only">
                                          {{ 'Remote Consulting for ' + item.desc + ' - ' + item1.subcoverage }}
                                        </span>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    class="px-4 py-3 align-middle text-center"
                                    v-if="
                                    (form.attorney_type.includes('REF') &&
                                      item1.plan_class == 'REF') ||
                                      (form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF') ||
                                      (!form.attorney_type.includes('REF') &&
                                        item1.plan_class != 'REF')
                                  "
                                  >
                                    <div class="relative inline-block w-10 align-middle select-none transition duration-200 ease-in">
                                      <input
                                        type="checkbox"
                                        name="toggle_service"
                                        :id="'toggle_service' + i + '_' + index"
                                        :aria-label="'Remote Services for ' + item.desc + ' - ' + item1.subcoverage"
                                        @change="
                                          check(
                                            {
                                              desc: item.desc,
                                              sub_cov_id: item1.sub_cov_id,
                                              sub_coverage: item1.subcoverage,
                                            },
                                            'remote_services',
                                            $event
                                          )
                                        "
                                        :disabled="
                                          !form?.coveragelist?.some(
                                            (el) => el.desc === item.desc
                                          ) ||
                                            !form.coveragelist.some(
                                              (el) =>
                                                el.sub_coverage ===
                                                item1.subcoverage
                                            )
                                        "
                                        class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                                      />
                                      <label
                                        :for="'toggle_service' + i + '_' + index"
                                        class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                                      >
                                        <span class="sr-only">
                                          {{ 'Remote Services for ' + item.desc + ' - ' + item1.subcoverage }}
                                        </span>
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="grid grid-cols-6 gap-4">
                <div class="col-span-6 sm:col-span-12">
                  <span
                    id="referral_cont_fee_label"
                    class="ml-6 text-md font-medium text-gray-900 float-left mr-5"
                  >
                    Referral Contingency/Federal or State Statute
                    <span class="text-red-700">*</span>
                  </span>

                  <div
                    class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in"
                  >
                    <input
                      type="checkbox"
                      name="toggle"
                      id="referral_cont_fee"
                      v-model="form.referral_cont_fee"
                      aria-labelledby="referral_cont_fee_label"
                      class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                    />
                    <label
                      for="referral_cont_fee"
                      class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                    >
                      <span class="sr-only">Toggle Referral Contingency/Federal or State Statute</span>
                    </label>
                  </div>
                  <p class="text-sm text-gray-500 ml-6">
                    Please note, plan coverage under this designation: Any case
                    in which attorney’s fees are recoverable on a contingency
                    basis or where fees for any attorney services required are
                    regulated by the attorney fee provisions of Federal and/or
                    State statute, the terms of said contingency agreement or
                    statutes shall control.
                  </p>
                  <div
                    class="text-red-600 mt-1 text-sm"
                    v-for="(error, index) in v$.form.referral_cont_fee.$errors"
                    :key="index"
                  >
                    <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-6 sm:col-span-3">
            <div class="shadow sm:rounded-md sm:overflow-hidden">
              <div class="bg-white border-b border-gray-400 py-5 px-4 sm:p-6">
                <h2 class="text-lg leading-6 font-medium text-gray-900">
                  Practice Area
                  <span class="text-red-700">*</span>
                </h2>
                <p class="mt-1 mb-4 text-sm text-gray-500">
                  Specify the State and County(ies) that you are willing to
                  provide service to our members. Select a State, then the
                  appropriate County and Plan Class, and click the plus button ( + ) to add it.
                </p>
                <div class="form-group grid grid-cols-6 gap-6 mt-2 mb-4">
                  <div class="col-span-6 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-900 mb-1" for="practice_area_state">State</label>
                    <select
                      id="practice_area_state"
                      class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
                      :disabled="form?.coveragelist?.length <= 0"
                      :value="form.prac_state?.STATECD || ''"
                      @change="onPracticeStateChange"
                    >
                      <option value="">State</option>
                      <option
                        v-for="state in practiceStateOptions"
                        :key="state.STATECD"
                        :value="state.STATECD"
                      >
                        {{ state.state_name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-900 mb-1" for="practice_area_county">County</label>
                    <select
                      id="practice_area_county"
                      class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
                      :disabled="form?.coveragelist?.length <= 0"
                      :value="form.county?.COUNTYNAME || ''"
                      @change="onPracticeCountyChange"
                    >
                      <option value="">County</option>
                      <option
                        v-for="county in practiceCountyOptions"
                        :key="county.COUNTYNAME"
                        :value="county.COUNTYNAME"
                      >
                        {{ county.COUNTYNAME }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-900 mb-1" for="practice_area_plan_class">Plan Class</label>
                    <select
                      id="practice_area_plan_class"
                      class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
                      :disabled="form?.coveragelist?.length <= 0"
                      :value="form.att_plan_class?.plan_class || ''"
                      @change="onPracticePlanClassChange"
                    >
                      <option value="">Plan Class</option>
                      <option
                        v-for="item in practicePlanClassOptions"
                        :key="item.plan_class"
                        :value="item.plan_class"
                      >
                        {{ item.plan_class }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6 sm:col-span-1 flex items-end">
                    <button
                      type="button"
                      @click="add_county()"
                      aria-label="Add practice area row"
                      class="inline-flex items-center p-1.5 border border-transparent rounded-full shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                      <span class="sr-only">Add</span>
                      <!-- Heroicon name: solid/plus -->
                      <svg
                        class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="flex flex-col">
                  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                      <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                          <thead class="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >State</th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >County</th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >Plan Class</th>
                              <th
                                scope="col"
                                class="px-6 w-32 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >
                                <span>
                                  <span class="float-left">CDL Rate</span>
                                  <p class="tooltip">
                                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                                    <span class="tooltip-text">Only applicable for CDL plans</span>
                                  </p>
                                </span>
                              </th>
                              <th
                                scope="col"
                                class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                              >Action</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="(item, i) in form.practice_county_list" :key="i">
                              <td
                                class="px-6 py-4 whitespace-nowrap text-center"
                              >{{ item.state_code }}</td>
                              <td class="px-6 py-4 whitespace-nowrap text-center">{{ item.county }}</td>
                              <td
                                class="px-6 py-4 whitespace-nowrap text-center"
                              >{{ item.plan_class }}</td>
                              <td class="px-6 py-4 whitespace-nowrap text-center">
                                <label class="sr-only" :for="'cdl_rate' + i">CDL Rate</label>
                                <text-input
                                  v-bind:value="item.cdl_rate"
                                  :id="'cdl_rate' + i"
                                  v-on:keyup="
                                      item.cdl_rate = $event.target['value']
                                    "
                                  :class="{
                                      'bg-gray-100': item.plan_class != 'CDL',
                                    }"
                                  :disabled="item.plan_class != 'CDL'"
                                ></text-input>
                              </td>
                              <td
                                v-if="item.deleted == 1 || item.deleted == '1'"
                                class="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-center"
                              >
                                <button
                                  type="button"
                                  @click="addCounty(i)"
                                  :aria-label="`Restore county row for ${item.county}, ${item.state_code} (${item.plan_class})`"
                                  class="mt-6 inline-flex items-center p-0.5 border border-transparent rounded-full shadow-sm text-white bg-[#ba4224] hover:bg-[#ba4224] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ba4224]"
                                >
                                  <svg
                                    class="h-5 w-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </button>
                                <div class>Deleted {{setDateFormat(item.date_deleted)}}</div>
                              </td>
                              <td
                                v-if="item.deleted != 1 && item.deleted != '1'"
                                class="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-center"
                              >
                                <button
                                  type="button"
                                  @click="ConfirmCountyDelete(i, item)"
                                  :aria-label="`Remove county row for ${item.county}, ${item.state_code} (${item.plan_class})`"
                                  class="mt-6 inline-flex items-center p-0.5 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                >
                                  <svg
                                    class="w-5 h-5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="3"
                                      d="M20 12H4"
                                    />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          class="text-red-600 mt-5 mb-5 text-sm ml-5"
                          v-for="(error, index) in v$.form.practice_county_list
                            .$errors"
                          :key="index"
                        >
                          <div v-if="error.$validator == 'required'">{{ error.$message }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="feeModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-3/5 md:w-full">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800">Fee Schedules - {{ fee_schedule_data?.desc }}</p>
              <i class="fa fa-close w-6 h-6 cursor-pointer" @click="openfeeSchedule(false)"></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
              <table class="divide-y divide-gray-200 w-full">
                <thead class="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      class="w-1/2 px-4 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Description</th>
                    <th
                      scope="col"
                      class="w-1/5 px-4 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Rate($)</th>
                    <th
                      v-if="
                        form?.credentials?.some(
                          (el) => el.lic_state?.STATECD === 'CA'
                        )
                      "
                      scope="col"
                      class="w-1/5 px-4 py-1 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >CA(state) Rate($)</th>
                    <th
                      scope="col"
                      class="w-1/4 px-4 py-1 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >Parameter</th>
                  </tr>
                </thead>
                <tbody
                  class="bg-white divide-y divide-gray-200 overflow-auto"
                  style="max-height: 500px;"
                >
                  <tr v-for="(item, index) in fee_schedule_data?.fee_schedule" :key="index">
                    <td class="px-2 py-2">{{ item.sub_coverage }}</td>
                    <td class="px-2 py-2 text-right">{{ item.fee_amount }}</td>
                    <td
                      class="px-2 py-2 text-right"
                      v-if="
                        form.credentials.some(
                          (el) => el.lic_state['STATECD'] === 'CA'
                        )
                      "
                    >{{ item.ca_fee_amount }}</td>
                    <td class="px-2 py-2 text-center">{{ item.parameter }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    <confirm-popup
      :showDeleteModal="showCountyDeleteModal"
      title="Delete"
      short_msg="Are you sure?"
      msg=" Do you really want to delete this county? This process cannot be undone."
      @click="cancelModal()"
      @remove="remove_county()"
    ></confirm-popup>
    <confirm-popup
      :showDeleteModal="showCovDeleteModal"
      title="Delete"
      short_msg="Are you sure?"
      msg=" Do you really want to delete this coverage? This process cannot be undone."
      @click="cancelModal()"
      @remove="remove_coverage()"
    ></confirm-popup>
  </div>
</template>
<style>
/* Coverages table column layout */
.coverage-div .coverages-table-wrap {
  max-width: 100%;
}
.coverage-div .coverages-table,
.coverage-div .coverages-subtable {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}
.coverage-div .coverages-table col.col-coverage,
.coverage-div .coverages-subtable col.col-coverage {
  width: 42%;
}
.coverage-div .coverages-table col.col-plan,
.coverage-div .coverages-subtable col.col-plan {
  width: 26%;
}
.coverage-div .coverages-table col.col-remote,
.coverage-div .coverages-subtable col.col-remote {
  width: 16%;
}
.coverage-div .coverages-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #f9fafb;
}

.coverage-div .coverage-row-header {
  display: grid;
  grid-template-columns: 42% 26% 16% 16%;
  align-items: center;
  width: 100%;
  min-height: 3.25rem;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
}

.coverage-div .coverage-cell {
  min-width: 0;
  padding-right: 0.75rem;
  box-sizing: border-box;
}

.coverage-div .coverage-cell-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 9.75rem;
  align-items: center;
  column-gap: 0.5rem;
  width: 100%;
}

.coverage-div .coverage-name {
  min-width: 0;
  line-height: 1.35;
  word-break: break-word;
}

.coverage-div .coverage-sub-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 9.75rem;
  margin: 0;
  padding: 0.25rem 0.5rem;
  line-height: 1.25;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #ba4224;
  border-radius: 0.375rem;
  background-color: #ba4224;
  color: #fff;
}

.coverage-div .coverage-sub-btn-spacer {
  display: block;
  width: 9.75rem;
  height: 1.75rem;
}

.coverage-div .tab:has(.tab-checkbox:checked) .coverage-sub-btn {
  box-shadow: inset 0 0 0 1px #fff;
}

.coverage-div .plan-class-cell,
.coverage-div .remote-cell {
  display: flex;
  align-items: center;
  min-width: 0;
  box-sizing: border-box;
}

.coverage-div .plan-class-cell {
  padding: 0 0.5rem;
}

.coverage-div .remote-cell {
  justify-content: center;
}

.coverage-div .plan-class-group {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.75rem 1.25rem;
}

.coverage-div .plan-class-option {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  cursor: pointer;
}

/* Accordion expand/collapse */
.coverage-div .tab-content {
  max-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.35s;
  -o-transition: max-height 0.35s;
  transition: max-height 0.35s;
}
.coverage-div .tab:has(.tab-checkbox:checked) .tab-content {
  max-height: 100vh;
  overflow: auto;
  width: 100%;
}

@media (max-width: 900px) {
  .coverage-div .coverage-row-header {
    grid-template-columns: 1fr;
    row-gap: 0.75rem;
  }
  .coverage-div .coverage-cell-inner {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .coverage-div .plan-class-cell,
  .coverage-div .remote-cell {
    justify-content: flex-start;
    padding-left: 0;
  }
}
</style>
<script>
import TextInput from "../Layout/Form/TextInput.vue"; // importing resuable input field
import ConfirmPopup from "../Layout/Modals/ConfirmPopup.vue"; // importing resuable delete modal
import useVuelidate from "@vuelidate/core"; // importing validation library
import { required } from "@vuelidate/validators"; // importing diffrene validation types from library.
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import Constants from "../../constants.ts"; // importing constant resubale variables.
import moment from "moment-timezone";

export default {
  name: "AppCoverages",
  setup() {
    return { v$: useVuelidate() }; //creating object to access validation object.
  },
  props: ["forms"], // To access variable passed from Parent component.
  data: function() {
    // declaring static variable for this component
    return {
      form: this.forms,
      API_BASE: Constants.API_BASE,
      showCountyDeleteModal: false,
      deleteCountyIndex: "",
      deleteCountyData: {},
      errors: [],
      fee_schedule_data: [],
      state_list: [],
      att_plan_list: [],
      plan_list: [],
      coverages: [],
      county_list: [],
      attorney_types: [
        { id: "FAM", name: "Family Defender (FAM)" },
        { id: "CDL", name: "CDL Defender (CDL)" },
        { id: "REF", name: "Referral (REF)" }
      ],
      flag_options: [
        { id: 1, name: "Yes" },
        { id: 0, name: "No" }
      ]
    };
  },
  // use to import central level variables from store
  computed: {
    ...mapState([
      "countyList",
      "att_user",
      "stateList",
      "profile_data",
      "tempAttData"
    ]),
    practiceStateOptions() {
      const states = [];
      (this.form.credentials || []).forEach((element) => {
        const lic = element?.lic_state;
        if (!lic || typeof lic !== "object" || !lic.STATECD) {
          return;
        }
        if (!states.some((s) => s.STATECD === lic.STATECD)) {
          states.push({
            state_name: lic.state_name,
            STATECD: lic.STATECD,
          });
        }
      });
      return states;
    },
    practiceCountyOptions() {
      return [{ COUNTYNAME: "All Counties" }, ...(this.countyList || [])];
    },
    practicePlanClassOptions() {
      return (this.form.coveragelist || []).reduce((unique, item) => {
        if (
          item?.plan_class &&
          !unique.some((obj) => obj.plan_class === item.plan_class)
        ) {
          unique.push(item);
        }
        return unique;
      }, []);
    },
  },
  // validations
  validations: {
    form: {
      referral_cont_fee: { required },
      practice_county_list: { required },
      attorney_type: { required }
    }
  },
  // calling methos from store to get plan class list from API
  mounted() {
    this.$store.dispatch("getState");
  },
  created() {
    // if attorney logged in and submitted enrollment form.
    this.$store.watch(
      () => this.$store.state.profile_data,
      value => {
        if (value != null) {
          if (this.att_user?.data && this.att_user != undefined) {
            //practices
            if (typeof this.profile_data?.attorney_type == "string") {
              this.form.first_name = this.profile_data?.first_name;
              this.form.attorney_type = this.profile_data?.attorney_type?.split(
                ","
              );
              this.$store.dispatch("getCoverages", this.form.attorney_type);
              this.form.practice_county_list = this.profile_data?.practice_states;
              this.form.credentials = this.profile_data?.credentials;
              for (
                let index = 0;
                index < this.form.credentials.length;
                index++
              ) {
                this.stateList?.forEach(state => {
                  if (state.STATECD == this.form.credentials[index].lic_state) {
                    this.form.credentials[index].lic_state = state;
                  }
                });
                if (this.form.credentials[index].lic_state?.STATECD == "CA") {
                  this.form.stateCount["CA"] = this.form.stateCount["CA"] + 1;
                } else {
                  this.form.stateCount["Others"] =
                    this.form.stateCount["Others"] + 1;
                }
              }

              if (typeof this.profile_data.attr_tags == "string") {
                this.profile_data.attr_tags = JSON.parse(
                  this.profile_data.attr_tags
                );
                if (this.profile_data.attr_tags.length > 0) {
                  this.profile_data.attr_tags.forEach(element => {
                    if (element.text == "Referral-Contingency-Fee") {
                      this.form.referral_cont_fee = true;
                      document.getElementById(
                        "referral_cont_fee"
                      ).checked = true;
                    }
                  });
                }
              }
            }
          }
        }
      },
      { immediate: true }
    );
    // to contiues watch on updates of store's variable
    this.$store.watch(
      () => this.$store.state.coverages,
      value => {
        if (value != undefined) {
          if (value.length > 0) {
            this.coverages = value;
            if (!(this.att_user?.data)) {
              this.$nextTick(() => {
                this.applyAttorneyCoverageAutoRules();
              });
            }
            if (this.att_user?.data && this.att_user != undefined) {
              this.form.remote_consulting = [];
              this.form.remote_services = [];
              setTimeout(() => {
                this.form.id = this.profile_data?.id;
                this.form.coveragelist = this.profile_data?.coverages || [];
                console.log(this.form.coveragelist, "this.form.coveragelist");
                this.form.coveragelist.forEach(element => {
                  element.desc = element.coverage_id;
                  element.plan_class = element.planclass;
                  element.sub_cov_id = element.subcov_id;
                  if (element.remote_consult == "1") {
                    this.form.remote_consulting.push(element);
                  }
                  if (element.remote_service == "1") {
                    this.form.remote_services.push(element);
                  }
                });
                this.applyAttorneyCoverageAutoRules();
                this.form.coveragelist.forEach(element => {
                  setTimeout(() => {
                    for (
                      let index = 0;
                      index < this.coverages.length;
                      index++
                    ) {
                      if (
                        this.coverages[index].sub_coverage &&
                        this.coverages[index].sub_coverage[0]["subcoverage"] !=
                          "" &&
                        this.coverages[index].sub_coverage.length > 1
                      ) {
                        let i = 0;
                        this.coverages[index]?.sub_coverage.forEach(el => {
                          if (element.subcov_id == el.sub_cov_id) {
                            for (
                              let index1 = 0;
                              index1 < this.coverages[index].plan_class.length;
                              index1++
                            ) {
                              if (
                                element.plan_class ==
                                this.coverages[index].plan_class[index1]
                              ) {
                                if(document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  )!=null && document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  )!=undefined){
                                    if (element.deleted != 1) {
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).checked = true;
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).style.border = "solid";
                                    } else {
                                      document.getElementById(
                                        "coverage_" + index + "_" + i + "_" + index1
                                      ).style.border = "solid red";
                                    }
                                  }
                              }
                            }
                           if(element.remote_service == "1"){
                            if(document.getElementById(
                                    "toggle_service" + index + "_" + i
                                  )!=null && document.getElementById(
                                    "toggle_service" + index + "_" + i
                                  )!=undefined){
                              document.getElementById(
                                "toggle_service" + index + "_" + i
                              ).checked = true;
                              }
                           } 
                            if (element.remote_consult == "1") {
                              if(document.getElementById(
                                    "toggle_" + index + "_" + i
                                  )!=null && document.getElementById(
                                    "toggle_" + index + "_" + i
                                  )!=undefined){
                              document.getElementById(
                                "toggle_" + index + "_" + i
                              ).checked = true;
                              }
                            }
                          } else {
                            if (
                              element.desc == this.coverages[index].desc &&
                              element.subcov_id == ""
                            ) {
                              for (
                                let index1 = 0;
                                index1 <
                                this.coverages[index].plan_class.length;
                                index1++
                              ) {
                                if (
                                  element.plan_class ==
                                  this.coverages[index].plan_class[index1]
                                ) {
                                  if(document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=undefined && document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=null){
                                  if (element.deleted != 1) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                              }
                              }
                              if (element.remote_consult == "1") {
                                if( document.getElementById(
                                  "toggle_" + index
                                )!=null &&  document.getElementById(
                                  "toggle_" + index
                                )!=undefined){
                                  document.getElementById(
                                    "toggle_" + index
                                  ).checked = true;
                                }
                              }
                              if (element.remote_service == "1") {
                                if( document.getElementById(
                                  "toggle_service" + index
                                )!=null &&  document.getElementById(
                                  "toggle_service" + index
                                )!=undefined){
                                  document.getElementById(
                                    "toggle_service" + index
                                  ).checked = true;
                                }
                              }
                            }
                          }
                          i++;
                        });
                      } else {
                        if (element.desc == this.coverages[index].desc) {
                          for (
                            let index1 = 0;
                            index1 < this.coverages[index].plan_class.length;
                            index1++
                          ) {
                            if (
                              element.plan_class ==
                              this.coverages[index].plan_class[index1]
                            ) {
                              if(document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=undefined && document.getElementById(
                                  "coverage_" + index + "_" + index1
                                )!=null){
                                  if (element.deleted != 1) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "none";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                            }
                          }
                          if(document.getElementById(
                              "toggle_" + index
                            )!=undefined && document.getElementById(
                              "toggle_" + index
                            )!=null){
                          if (element.remote_consult == "1") {
                            document.getElementById(
                              "toggle_" + index
                            ).checked = true;
                          }
                        }
                          if(document.getElementById(
                              "toggle_service" + index
                            )!=undefined && document.getElementById(
                              "toggle_service" + index
                            )!=null){
                              if (element.remote_service == "1") {
                            document.getElementById(
                              "toggle_service" + index
                            ).checked = true;
                          }
                        }

                        }
                      }
                    }
                  }, 1000);
                });
              }, 1000);
            } else if (this.tempAttData.is_attorney_exist) {
              setTimeout(() => {
                this.applyAttorneyCoverageAutoRules();
                this.form.coveragelist.forEach(element => {
                  element.subcov_id = element.sub_cov_id;
                  setTimeout(() => {
                    for (
                      let index = 0;
                      index < this.coverages.length;
                      index++
                    ) {
                      if (
                        this.coverages[index].sub_coverage &&
                        this.coverages[index].sub_coverage[0]["subcoverage"] !=
                          "" &&
                        this.coverages[index].sub_coverage.length > 1
                      ) {
                        let i = 0;
                        this.coverages[index].sub_coverage.forEach(el => {
                          if (element.subcov_id == el.sub_cov_id) {
                            for (
                              let index1 = 0;
                              index1 < this.coverages[index].plan_class.length;
                              index1++
                            ) {
                              if (
                                element.plan_class ==
                                this.coverages[index].plan_class[index1]
                              ) {
                                if (element.deleted != 1 || element.deleted) {
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).checked = true;
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).style.border = "solid";
                                } else {
                                  document.getElementById(
                                    "coverage_" + index + "_" + i + "_" + index1
                                  ).style.border = "solid red";
                                }
                              }
                            }
                            if (this.form.remote_services.some(
                              el =>
                                 el.plan_class.length > 0 &&
                                 el.desc == this.coverages[index].desc
                            )) {
                            document.getElementById(
                                "toggle_service" + index + "_" + i
                              ).checked = true;
                            } 
                            if (
                              this.form.remote_consulting.some(
                                el =>
                                  el.plan_class.length > 0 &&
                                  el.desc == this.coverages[index].desc
                              )
                            ) {
                              document.getElementById(
                                "toggle_" + index + "_" + i
                              ).checked = true;
                            }
                          } else {
                            if (
                              element.desc == this.coverages[index].desc &&
                              !element.subcov_id
                            ) {
                              for (
                                let index1 = 0;
                                index1 <
                                this.coverages[index].plan_class.length;
                                index1++
                              ) {
                                if (
                                  element.plan_class ==
                                  this.coverages[index].plan_class[index1]
                                ) {
                                  if (
                                    element.deleted != 1 ||
                                    !element.deleted
                                  ) {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).checked = true;
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid";
                                  } else {
                                    document.getElementById(
                                      "coverage_" + index + "_" + index1
                                    ).style.border = "solid red";
                                  }
                                }
                              }
                              if (
                                this.form.remote_consulting.some(
                                  el =>
                                    el.plan_class.length > 0 &&
                                    el.desc == this.coverages[index].desc
                                )
                              ) {
                                document.getElementById(
                                  "toggle_" + index
                                ).checked = true;
                              }
                              if (
                                this.form?.remote_services?.some(
                                  el =>
                                    el.plan_class.length > 0 &&
                                    el.desc == this.coverages[index].desc
                                )
                              ) {
                                document.getElementById(
                                  "toggle_service" + index
                                ).checked = true;
                              }
                            }
                          }
                          i++;
                        });
                      } else {
                        if (element.desc == this.coverages[index].desc) {
                          for (
                            let index1 = 0;
                            index1 < this.coverages[index].plan_class.length;
                            index1++
                          ) {
                            if (
                              element.plan_class ==
                              this.coverages[index].plan_class[index1]
                            ) {
                              if (element.deleted != 1) {
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).checked = true;
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).style.border = "none";
                              } else {
                                document.getElementById(
                                  "coverage_" + index + "_" + index1
                                ).style.border = "solid red";
                              }
                            }
                          }
                          if (
                            this.form.remote_consulting.some(
                              el =>
                                el.plan_class.length > 0 &&
                                el.desc == this.coverages[index].desc
                            )
                          ) {
                            document.getElementById(
                              "toggle_" + index
                            ).checked = true;
                          }
                          if (
                            this.form?.remote_services?.some(
                              el =>
                                el.plan_class.length > 0 &&
                                el.desc == this.coverages[index].desc
                            )
                          ) {
                            document.getElementById(
                              "toggle_service" + index
                            ).checked = true;
                          }
                        }
                      }
                    }
                  }, 1000);
                });
              }, 1000);
            }
          }
        } else {
          this.coverages = [];
        }
      }
    );
  },
  //importing resuable components to use in current component
  components: {
    TextInput,
    ConfirmPopup
  },
  // All static methods of this component
  methods: {
    hasSubCoverages(item) {
      return (
        item?.sub_coverage &&
        item.sub_coverage[0]?.subcoverage != "" &&
        item.sub_coverage.length > 1
      );
    },
    sortedPlanClasses(planClasses) {
      const order = { FAM: 0, CDL: 1, REF: 2 };
      return [...(planClasses || [])].sort(
        (a, b) => (order[a] ?? 99) - (order[b] ?? 99)
      );
    },
    attorneySubPlanClassAllowed(planClass, subPlanClass) {
      if (planClass === "FAM") {
        return !subPlanClass || String(subPlanClass).trim() === "";
      }
      return true;
    },
    findPortalSubRecord(coverageName, subcoverageName, planClass) {
      const coverage = (this.coverages || []).find(
        (c) => c.desc === coverageName
      );
      if (!coverage?.sub_coverage?.length) {
        return null;
      }
      const matches = coverage.sub_coverage.filter(
        (s) => s.subcoverage === subcoverageName
      );
      for (let i = 0; i < matches.length; i++) {
        if (this.attorneySubPlanClassAllowed(planClass, matches[i].plan_class)) {
          return matches[i];
        }
      }
      return matches[0] || null;
    },
    // Matches deleted rows too, so they can be revived instead of duplicated
    findPortalCoverageRow(planClass, coverageDesc, subCovId) {
      return (this.form.coveragelist || []).find((row) => {
        if (
          row.plan_class !== planClass ||
          (row.desc !== coverageDesc && row.coverage_id !== coverageDesc)
        ) {
          return false;
        }
        const rowSubId =
          row.sub_cov_id == null || row.sub_cov_id === ""
            ? null
            : String(row.sub_cov_id);
        const cmpId =
          subCovId == null || subCovId === "" ? null : String(subCovId);
        return rowSubId === cmpId;
      });
    },
    revivePortalCoverageRow(row) {
      row.deleted = 0;
      row.date_deleted = null;
      row.new = 1;
    },
    hasPortalCoverageRow(planClass, coverageDesc, subCovId) {
      const row = this.findPortalCoverageRow(planClass, coverageDesc, subCovId);
      return !!row && row.deleted != 1;
    },
    addPortalCoverageRow(planClass, coverageDesc, subcoverageName) {
      if (!this.form.coveragelist) {
        this.form.coveragelist = [];
      }
      const subRecord = this.findPortalSubRecord(
        coverageDesc,
        subcoverageName,
        planClass
      );
      if (!subRecord) {
        return false;
      }
      const existing = this.findPortalCoverageRow(
        planClass,
        coverageDesc,
        subRecord.sub_cov_id
      );
      if (existing) {
        if (existing.deleted != 1) {
          return false;
        }
        this.revivePortalCoverageRow(existing);
        return true;
      }
      this.form.coveragelist.push({
        plan_class: planClass,
        desc: coverageDesc,
        coverage_id: coverageDesc,
        planclass: planClass,
        sub_cov_id: subRecord.sub_cov_id,
        subcov_id: subRecord.sub_cov_id,
        sub_coverage: subcoverageName,
        new: 1,
        deleted: 0,
      });
      return true;
    },
    syncPortalCoverageCheckbox(planClass, coverageDesc, subCovId, checked = true) {
      for (let i = 0; i < (this.coverages || []).length; i++) {
        const coverage = this.coverages[i];
        if (coverage.desc !== coverageDesc) {
          continue;
        }
        const planIdx = (coverage.plan_class || []).indexOf(planClass);
        if (planIdx < 0) {
          continue;
        }
        const hasSubs =
          coverage.sub_coverage &&
          coverage.sub_coverage[0]?.subcoverage !== "" &&
          coverage.sub_coverage.length > 1;
        if (hasSubs) {
          const subIdx = coverage.sub_coverage.findIndex(
            (s) => String(s.sub_cov_id) === String(subCovId)
          );
          if (subIdx < 0) {
            continue;
          }
          const el = document.getElementById(
            "coverage_" + i + "_" + subIdx + "_" + planIdx
          );
          if (el) {
            el.checked = checked;
            el.style.border = checked ? "solid" : "";
          }
        } else {
          const el = document.getElementById(
            "coverage_" + i + "_" + planIdx
          );
          if (el) {
            el.checked = checked;
            el.style.border = checked ? "solid" : "";
          }
        }
      }
    },
    resolvePortalSubName(row) {
      let subName = row.sub_coverage || row.subcoverage_name || "";
      if ((!subName || subName === "-") && row.sub_cov_id) {
        const cov = row.desc || row.coverage_id;
        const coverage = (this.coverages || []).find((c) => c.desc === cov);
        const match = coverage?.sub_coverage?.find(
          (s) => String(s.sub_cov_id) === String(row.sub_cov_id)
        );
        subName = match?.subcoverage || "";
        if (subName) {
          row.sub_coverage = subName;
        }
      }
      return subName;
    },
    removePortalCoverageRow(planClass, coverageDesc, subcoverageName) {
      if (!this.form.coveragelist) {
        return false;
      }
      const subRecord = this.findPortalSubRecord(
        coverageDesc,
        subcoverageName,
        planClass
      );
      if (!subRecord) {
        return false;
      }
      const today = moment(new Date()).format("YYYY-MM-DD");
      let removed = false;
      const nextList = [];
      this.form.coveragelist.forEach((row) => {
        const matches =
          row.deleted != 1 &&
          row.plan_class == planClass &&
          (row.desc === coverageDesc || row.coverage_id === coverageDesc) &&
          String(row.sub_cov_id) === String(subRecord.sub_cov_id);
        if (!matches) {
          nextList.push(row);
          return;
        }
        removed = true;
        if (row.id != undefined) {
          nextList.push({
            ...row,
            deleted: 1,
            date_deleted: today,
          });
        }
      });
      if (removed) {
        this.form.coveragelist = nextList;
        this.syncPortalCoverageCheckbox(
          planClass,
          coverageDesc,
          subRecord.sub_cov_id,
          false
        );
      }
      return removed;
    },
    hasActivePortalSub(planClass, coverageDesc, subcoverageName) {
      return (this.form.coveragelist || []).some((row) => {
        if (row.deleted == 1) {
          return false;
        }
        if (
          row.plan_class !== planClass ||
          (row.desc !== coverageDesc && row.coverage_id !== coverageDesc)
        ) {
          return false;
        }
        return this.resolvePortalSubName(row) === subcoverageName;
      });
    },
    pruneAttorneyCoverageAutoRules(planClass) {
      if (!this.form.coveragelist) {
        return;
      }
      const civilJurisdictionTriggers = {
        "Consumer Protection": [
          "Consumer Protection - General Civil Jurisdiction",
          "Consumer Protection - Limited Jurisdiction",
        ],
        "Debt Collection Defense": [
          "Debt Collection Defense - General Civil Jurisdiction",
          "Debt Collection Defense - Limited Jurisdiction",
        ],
        "Personal Property Protection": [
          "Personal Property Protection - General Civil Jurisdiction",
          "Personal Property Protection - Limited Jurisdiction",
        ],
      };
      const planClasses = {};
      if (planClass) {
        planClasses[planClass] = true;
      }
      (this.form.coveragelist || []).forEach((row) => {
        if (row.plan_class) {
          planClasses[row.plan_class] = true;
        }
      });
      Object.keys(planClasses).forEach((pc) => {
        if (
          !this.hasActivePortalSub(
            pc,
            "Real Estate",
            "Sale or Purchase of Primary Residence"
          )
        ) {
          this.removePortalCoverageRow(
            pc,
            "Real Estate",
            "Sale or Purchase of Secondary Residence"
          );
        }
        if (
          !this.hasActivePortalSub(
            pc,
            "Real Estate",
            "Refinance of Primary Residence"
          )
        ) {
          this.removePortalCoverageRow(
            pc,
            "Real Estate",
            "Refinance of Secondary Residence"
          );
        }
        Object.keys(civilJurisdictionTriggers).forEach((trigger) => {
          if (!this.hasActivePortalSub(pc, "Civil", trigger)) {
            civilJurisdictionTriggers[trigger].forEach((extra) => {
              this.removePortalCoverageRow(pc, "Civil", extra);
            });
          }
        });
        const hasOtherCivil = (this.form.coveragelist || []).some((row) => {
          if (row.deleted == 1 || row.plan_class !== pc) {
            return false;
          }
          if (row.desc !== "Civil" && row.coverage_id !== "Civil") {
            return false;
          }
          const subName = this.resolvePortalSubName(row);
          return subName && subName !== "Other";
        });
        if (!hasOtherCivil) {
          this.removePortalCoverageRow(pc, "Civil", "Other");
        }
      });
    },
    applyAttorneyCoverageAutoRules(triggerPlanClass) {
      if (!this.form.coveragelist) {
        this.form.coveragelist = [];
      }
      const civilJurisdictionTriggers = {
        "Consumer Protection": [
          "Consumer Protection - General Civil Jurisdiction",
          "Consumer Protection - Limited Jurisdiction",
        ],
        "Debt Collection Defense": [
          "Debt Collection Defense - General Civil Jurisdiction",
          "Debt Collection Defense - Limited Jurisdiction",
        ],
        "Personal Property Protection": [
          "Personal Property Protection - General Civil Jurisdiction",
          "Personal Property Protection - Limited Jurisdiction",
        ],
      };
      const defaultDocSubcoverages = [
        "Document Preparation",
        "Document Review",
      ];
      const docCoverageName = "Document Preparation/Review";
      // Document Prep/Review is only offered under FAM and REF
      const docDefaultPlanClasses = ["FAM", "REF"];
      const collectPlanClasses = () => {
        const set = {};
        if (triggerPlanClass) {
          set[triggerPlanClass] = true;
        }
        (this.form.coveragelist || []).forEach((row) => {
          if (row.deleted != 1 && row.plan_class) {
            set[row.plan_class] = true;
          }
        });
        (this.form.attorney_type || []).forEach((type) => {
          if (type === "FAM" || type === "REF") {
            set[type] = true;
          }
        });
        return Object.keys(set);
      };
      let addedRows = [];
      for (let pass = 0; pass < 6; pass++) {
        let changed = false;
        const planClasses = collectPlanClasses();
        planClasses.forEach((planClass) => {
          if (!docDefaultPlanClasses.includes(planClass)) {
            return;
          }
          defaultDocSubcoverages.forEach((subName) => {
            if (this.addPortalCoverageRow(planClass, docCoverageName, subName)) {
              addedRows.push({
                plan_class: planClass,
                desc: docCoverageName,
                sub_coverage: subName,
              });
              changed = true;
            }
          });
        });
        const snapshot = (this.form.coveragelist || []).filter(
          (r) => r.deleted != 1
        );
        snapshot.forEach((row) => {
          const pc = row.plan_class;
          const cov = row.desc || row.coverage_id;
          let subName = row.sub_coverage || row.subcoverage_name || "";
          if ((!subName || subName === "-") && row.sub_cov_id) {
            const coverage = (this.coverages || []).find((c) => c.desc === cov);
            const match = coverage?.sub_coverage?.find(
              (s) => String(s.sub_cov_id) === String(row.sub_cov_id)
            );
            subName = match?.subcoverage || "";
            if (subName) {
              row.sub_coverage = subName;
            }
          }
          if (cov === "Civil" && subName && subName !== "Other") {
            if (this.addPortalCoverageRow(pc, "Civil", "Other")) {
              addedRows.push({
                plan_class: pc,
                desc: "Civil",
                sub_coverage: "Other",
              });
              changed = true;
            }
          }
          if (cov === "Civil" && civilJurisdictionTriggers[subName]) {
            civilJurisdictionTriggers[subName].forEach((extra) => {
              if (this.addPortalCoverageRow(pc, "Civil", extra)) {
                addedRows.push({
                  plan_class: pc,
                  desc: "Civil",
                  sub_coverage: extra,
                });
                changed = true;
              }
            });
          }
          if (
            cov === "Real Estate" &&
            subName === "Sale or Purchase of Primary Residence"
          ) {
            if (
              this.addPortalCoverageRow(
                pc,
                "Real Estate",
                "Sale or Purchase of Secondary Residence"
              )
            ) {
              addedRows.push({
                plan_class: pc,
                desc: "Real Estate",
                sub_coverage: "Sale or Purchase of Secondary Residence",
              });
              changed = true;
            }
          }
          if (
            cov === "Real Estate" &&
            subName === "Refinance of Primary Residence"
          ) {
            if (
              this.addPortalCoverageRow(
                pc,
                "Real Estate",
                "Refinance of Secondary Residence"
              )
            ) {
              addedRows.push({
                plan_class: pc,
                desc: "Real Estate",
                sub_coverage: "Refinance of Secondary Residence",
              });
              changed = true;
            }
          }
        });
        if (!changed) {
          break;
        }
      }
      this.$nextTick(() => {
        addedRows.forEach((row) => {
          const sub = this.findPortalSubRecord(
            row.desc,
            row.sub_coverage,
            row.plan_class
          );
          if (sub) {
            this.syncPortalCoverageCheckbox(
              row.plan_class,
              row.desc,
              sub.sub_cov_id
            );
          }
        });
      });
      return addedRows.length > 0;
    },
    //Code for Add and remove coverage and remote consulting from array
    ensureRemoteArrays: function() {
      if (!Array.isArray(this.form.remote_consulting)) {
        this.form.remote_consulting = [];
      }
      if (!Array.isArray(this.form.remote_services)) {
        this.form.remote_services = [];
      }
    },
    // Match a remote toggle entry to a coveragelist row
    remoteMatchesCoverage: function(remote, cov) {
      const remoteDesc = remote?.desc || remote?.coverage_id;
      const covDesc = cov?.desc || cov?.coverage_id;
      if (!remoteDesc || remoteDesc !== covDesc) {
        return false;
      }
      const remoteSubId =
        remote?.sub_cov_id != null && remote.sub_cov_id !== ""
          ? remote.sub_cov_id
          : remote?.subcov_id;
      const covSubId =
        cov?.sub_cov_id != null && cov.sub_cov_id !== ""
          ? cov.sub_cov_id
          : cov?.subcov_id;
      if (remoteSubId != null && remoteSubId !== "") {
        return String(covSubId) === String(remoteSubId);
      }
      if (remote?.sub_coverage) {
        return (
          cov?.sub_coverage === remote.sub_coverage ||
          cov?.subcoverage === remote.sub_coverage
        );
      }
      // Coverage-level remote toggle (no subcoverage): apply to all plan classes
      return true;
    },
    // Persist remote flags onto coveragelist rows so create/update APIs keep them
    applyRemoteFlagsToCoveragelist: function() {
      this.ensureRemoteArrays();
      if (!Array.isArray(this.form.coveragelist)) {
        return;
      }
      this.form.coveragelist.forEach((cov) => {
        const hasConsult = this.form.remote_consulting.some((el) =>
          this.remoteMatchesCoverage(el, cov)
        );
        const hasService = this.form.remote_services.some((el) =>
          this.remoteMatchesCoverage(el, cov)
        );
        cov.remote_consult = hasConsult ? "1" : "0";
        cov.remote_service = hasService ? "1" : "0";
      });
    },
    updateRemoteArray: function(field, data, checked) {
      this.ensureRemoteArrays();
      if (!Array.isArray(this.form.coveragelist)) {
        this.form.coveragelist = [];
      }
      const flagKey =
        field === "remote_consulting" ? "remote_consult" : "remote_service";
      // Write flags onto matching coveragelist rows (source of truth for API)
      this.form.coveragelist.forEach((cov) => {
        if (!this.remoteMatchesCoverage(data, cov)) {
          return;
        }
        if (checked && cov.deleted == 1) {
          return;
        }
        cov[flagKey] = checked ? "1" : "0";
      });
      // Rebuild remote arrays from coveragelist so payload stays valid
      // (avoids pushing catalog plan_class arrays like ["FAM","REF"])
      this.form.remote_consulting = this.form.coveragelist.filter(
        (c) => c.deleted != 1 && String(c.remote_consult) === "1"
      );
      this.form.remote_services = this.form.coveragelist.filter(
        (c) => c.deleted != 1 && String(c.remote_service) === "1"
      );
    },
    check: function(data, field, event) {
      console.log("filed",field);
      console.log("data",data);
      console.log("event",event.target.checked);
      if (field == "remote_consulting" || field == "remote_services") {
        this.updateRemoteArray(field, data, event.target.checked);
      }else if (field == "coveragelist") {
        var today = moment(new Date()).format("YYYY-MM-DD");
        if (event.target.checked) {
          console.log(data);
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  el.sub_cov_id == data.sub_cov_id
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.sub_cov_id ==
                    this.form.coveragelist[index]["sub_cov_id"] &&
                  data.plan_class == this.form.coveragelist[index]["plan_class"]
                ) {
                  this.revivePortalCoverageRow(
                    this.form.coveragelist[index]
                  );
                }
              }
            } else {
              this.form.coveragelist.push(data);
            }
          } else {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  (!el.sub_cov_id ||
                    el.sub_cov_id == null ||
                    el.sub_cov_id == "")
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"] &&
                  !this.form.coveragelist[index]["sub_cov_id"]
                ) {
                  console.log(data, "data");
                  this.revivePortalCoverageRow(
                    this.form.coveragelist[index]
                  );
                }
              }
            } else {
              this.form.coveragelist.push(data);
            }
          }
          this.applyRemoteFlagsToCoveragelist();
        } else {
          if (data.sub_cov_id != null && data.sub_cov_id != undefined) {
            if (
              this.form.coveragelist.some(
                el =>
                  el.sub_cov_id == data.sub_cov_id &&
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  el.id != undefined
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.sub_cov_id ==
                    this.form.coveragelist[index]["sub_cov_id"] &&
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"]
                ) {
                  console.log(this.form.coveragelist[index], "data");
                  this.form.coveragelist[index]["deleted"] = 1;
                  this.form.coveragelist[index]["date_deleted"] = today;
                }
              }
            } else {
              this.form.coveragelist = this.form.coveragelist.filter(function(
                el
              ) {
                if (
                  el.sub_cov_id == data.sub_cov_id &&
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc
                ) {
                  return false;
                } else {
                  return true;
                }
              });
            }
          } else {
            if (
              this.form.coveragelist.some(
                el =>
                  el.plan_class == data.plan_class &&
                  el.id != undefined &&
                  el.desc == data.desc
              )
            ) {
              for (
                let index = 0;
                index < this.form.coveragelist.length;
                index++
              ) {
                if (
                  data.plan_class ==
                    this.form.coveragelist[index]["plan_class"] &&
                  data.desc == this.form.coveragelist[index]["desc"] &&
                  this.form.coveragelist[index]["sub_cov_id"] == ""
                ) {
                  console.log(this.form.coveragelist[index], "data");
                  this.form.coveragelist[index]["deleted"] = 1;
                  this.form.coveragelist[index]["date_deleted"] = today;
                  console.log(data, "data");
                }
              }
            } else {
              console.log(data);
              this.form.coveragelist = this.form.coveragelist.filter(function(
                el
              ) {
                if (
                  el.plan_class == data.plan_class &&
                  el.desc == data.desc &&
                  (!el.sub_cov_id ||
                    el.sub_cov_id == null ||
                    el.sub_cov_id == "")
                ) {
                  return false;
                } else {
                  return true;
                }
              });
            }
          }
        }
        console.log(this.form.coveragelist, "this.form.coveragelist");
        if (field == "coveragelist" && event.target.checked) {
          this.applyAttorneyCoverageAutoRules(data.plan_class);
        } else if (field == "coveragelist" && !event.target.checked) {
          this.pruneAttorneyCoverageAutoRules(data.plan_class);
        }
      }
    },
    getCoverages: function(value) {
      this.$store.dispatch("getCoverages", this.form.attorney_type);
      if (value != "CDL") {
        if (
          this.form.attorney_type.includes("FAM") &&
          this.form.attorney_type.includes("REF")
        ) {
          this.openCovDetail(true);
        }
      }
      this.$nextTick(() => {
        this.applyAttorneyCoverageAutoRules(value === "CDL" ? null : value);
      });
    },
    openCovDetail: function(value) {
      if (value) {
        document.getElementById("covModal").removeAttribute("class");
      } else {
        document.getElementById("covModal").setAttribute("class", "hidden");
      }
    },
    // Filter dropdown list on Dropdown based on typed value
    searchAutocomplete: function(event, field) {
      if (field == "state") {
        let statesLicense = [];
        this.form.credentials.forEach(element => {
          statesLicense.push({
            state_name: element.lic_state.state_name,
            STATECD: element.lic_state.STATECD
          });
        });
        console.log(this.form.credentials);
        if (!event.query.trim().length) {
          this.state_list = [...statesLicense];
        } else {
          this.state_list = statesLicense.filter(item => {
            return item.state_name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
        var result = this.state_list.reduce((unique, o) => {
          if (!unique.some(obj => obj.state_name === o.state_name)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.state_list = result;
      } else if (field == "county") {
        if (!event.query.trim().length) {
          this.county_list = [...this.countyList];
          this.county_list.unshift({'COUNTYNAME':'All Counties'});
        } else {
          this.county_list = this.countyList.filter(item => {
            return item.COUNTYNAME.toLowerCase().startsWith(
              event.query.toLowerCase()
            );
          });
        }
      } else if (field == "attorney_planclass") {
        console.log(this.form.coveragelist);
        if (!event.query.trim().length) {
          this.att_plan_list = [...this.form.coveragelist];
        } else {
          this.att_plan_list = this.form.coveragelist.filter(item => {
            console.log(item);
            return item.plan_class
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
        var result1 = this.att_plan_list.reduce((unique, o) => {
          if (!unique.some(obj => obj.plan_class === o.plan_class)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.att_plan_list = result1;
      }
    },
    //On Click View More button opening modal to display fee details
    openfeeSchedule: function(value, data = null) {
      if (value) {
        this.fee_schedule_data = data;
        document.getElementById("feeModal").removeAttribute("class");
      } else {
        document.getElementById("feeModal").setAttribute("class", "hidden");
      }
    },
    // code to download pdf
    download: function(path) {
      window.open(path);
    },
    //Submit and Validate form
    submitApplication: function() {
      this.applyAttorneyCoverageAutoRules();
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.applyRemoteFlagsToCoveragelist();
      if (
        this.form.referral_cont_fee != null ||
        this.form.referral_cont_fee != ""
      ) {
        if (this.form.referral_cont_fee == true) {
          this.form.attr_tags = JSON.stringify([
            { text: "Referral-Contingency-Fee" }
          ]);
          console.log(this.form.attr_tags);
        }
      }
      
    },
    // On Select State calling method from store to get County list based on State
    onPracticeStateChange(event) {
      const code = event.target.value;
      const found = this.practiceStateOptions.find(
        (state) => state.STATECD === code
      );
      this.form.prac_state = found || null;
      this.form.county = null;
      if (found?.STATECD) {
        this.$store.dispatch("getCounty", found.STATECD);
      }
    },
    onPracticeCountyChange(event) {
      const name = event.target.value;
      if (!name) {
        this.form.county = null;
        return;
      }
      if (name === "All Counties") {
        this.form.county = { COUNTYNAME: "All Counties" };
        return;
      }
      const found = (this.countyList || []).find(
        (county) => county.COUNTYNAME === name
      );
      this.form.county = found || { COUNTYNAME: name };
    },
    onPracticePlanClassChange(event) {
      const planClass = event.target.value;
      if (!planClass) {
        this.form.att_plan_class = null;
        return;
      }
      const found = this.practicePlanClassOptions.find(
        (item) => item.plan_class === planClass
      );
      this.form.att_plan_class = found || { plan_class: planClass };
    },
    onSelect: function(event, field) {
      if (field == "state") {
        this.$store.dispatch("getCounty", event.value.STATECD);
      }
    },
    // Code to add more practice county
    add_county: function() {
      if (
        this.form.prac_state == "" ||
        this.form.county == "" ||
        this.form.county == null ||
        this.form.att_plan_class == "" ||
        this.form.att_plan_class == null ||
        this.form.prac_state == null
      ) {
        this.$toast.error("Please select State and County!");
      } else {
        console.log(this.form.att_plan_class.plan_class);
        console.log(this.form.prac_state.STATECD);
        console.log(this.form.county.COUNTYNAME)
        console.log(this.form.practice_county_list)
        if (
          this.form.practice_county_list.some(
            el => (el.state_code == this.form.prac_state.STATECD) && (el.county == this.form.county.COUNTYNAME) && (el.plan_class == this.form.att_plan_class.plan_class)
          )
        ) {
          this.$toast.error("Duplicate Practice County");
        } else {
          if(this.form.county.COUNTYNAME=='All Counties'){
            (this.countyList || []).forEach(element => {
              if (this.form.practice_county_list.some(
              el => el.state_code == this.form.prac_state.STATECD
              && el.county == element.COUNTYNAME
              && el.plan_class == this.form.att_plan_class.plan_class)) 
              {
               //
               console.log("duplicate");
              }else{
                 if(element.COUNTYNAME!="All Counties"){
                  this.form.practice_county_list.push({
                state_code: this.form.prac_state.STATECD,
                county:  element.COUNTYNAME,
                plan_class: this.form.att_plan_class.plan_class,
                date_deleted: ""
              });
                }
              }
            });
          }else{
            this.form.practice_county_list.push({
              state_code: this.form.prac_state.STATECD,
              county: this.form.county.COUNTYNAME,
              plan_class: this.form.att_plan_class.plan_class,
              date_deleted: ""
            });
          }
          console.log(this.form.practice_county_list);
        }
      }
      this.form.prac_state = null;
      this.form.county = null;
      this.form.att_plan_class = null;
    },
    addCounty: function(index) {
      this.form.practice_county_list[index].deleted = 0;
      this.form.practice_county_list[index]["date_deleted"] = "";
    },
    // Code to remove practice county from county array
    remove_county: function() {
      var today = moment(new Date()).format("YYYY-MM-DD");
      if (
        this.form.practice_county_list.some(
          el =>
            el.state_code == this.deleteCountyData.state_code &&
            el.id != undefined
        ) &&
        this.form.practice_county_list.some(
          el =>
            el.plan_class == this.deleteCountyData.plan_class &&
            el.id != undefined
        ) &&
        this.form.practice_county_list.some(
          el => el.county == this.deleteCountyData.county && el.id != undefined
        )
      ) {
        for (
          let index = 0;
          index < this.form.practice_county_list.length;
          index++
        ) {
          if (
            this.deleteCountyData.state_code ==
              this.form.practice_county_list[index]["state_code"] &&
            this.deleteCountyData.plan_class ==
              this.form.practice_county_list[index]["plan_class"] &&
            this.deleteCountyData.county ==
              this.form.practice_county_list[index]["county"]
          ) {
            this.form.practice_county_list[index]["deleted"] = 1;
            this.form.practice_county_list[index]["date_deleted"] = today;
          }
        }
      } else {
        this.form.practice_county_list.splice(this.deleteCountyIndex, 1);
      }
      console.log(this.form.practice_county_list);
    },
    //On cancel modal of delete
    cancelModal: function() {
      this.showCountyDeleteModal = false;
    },
    // confirmation modal for delete practice county
    ConfirmCountyDelete: function(index, data) {
      this.showCountyDeleteModal = true;
      this.deleteCountyIndex = index;
      this.deleteCountyData = data;
    },
    setDateFormat: function(date) {
      if (date != null && date != "") {
        return moment(date).format("MMM DD YYYY");
      }
    }
  }
};
</script>
